import workspace from "../../workspace";
import COLOR_THEMES from "../../../store/colorThemes";
import sqftConfig from "../../../store/sqftConfig";
import store from "../../../../../../../store";
import SeamTool from "./slabParts/seamTool";
import {RENDER_TEMPLATES, SHAPE_PART_ID, SIDEBAR_SLAB_SEAM_BUTTONS} from "../../../../../constants";
import RenderParts from "../../../helpers/renderParts";
import ShapeMeasurementArrows from "./shapeMeasurementArrows";
import ShapeAbsolute from "./shapeAbsolute";
import workspaceControllers from "../../../store/workspaceControllers";
import {getPointField} from "../../../../../helpers/sqftHelper";
import RenderFigures from "../../../helpers/renderFigures";
import {pickPulsedColor} from "../../../helpers/commonParts/blink";
import {COLOR} from "../../../store/colorThemes";

class ShapeSlab {
  __shape;
  __seamTool;
  __intersectionPoints = [];
  __minLengthToIntersectionPoints;
  __absolutePos = null; //not used?
  shapeAbsolute = new ShapeAbsolute(this);
  __freeSeamValidations = new Map(); // Map<lineId, validation>

  constructor(shape) {
    this.__shape = shape;
    this.__seamTool = new SeamTool(shape);
    this.__measurementArrows = new ShapeMeasurementArrows(shape);
  }

  setSlabPos(pos) {
    this.__shape.slabPos = pos
  }
  setParentId(parentId) {
    this.__shape.shapeParentId = parentId
  }
  getParentId() {
    return this.__shape.shapeParentId
  }
  setRotationDegreesSlab(rotationDegrees) {
    this.__shape.rotatedDegreesSlab = rotationDegrees
  }
  addSeamPieceVertical = (mousePos) => {
    this.__seamTool.addSeamPieceVertical(mousePos);
    workspaceControllers.snappedShapeGroups.updateShapesSnappedGroups(false);
  };
  addSeamPieceHorizontal = (mousePos) => {
    this.__seamTool.addSeamPieceHorizontal(mousePos);
    workspaceControllers.snappedShapeGroups.updateShapesSnappedGroups(false);
  };
  addFreeSeam = () => {
    this.__seamTool.addFreeSeam();
    workspaceControllers.snappedShapeGroups.updateShapesSnappedGroups(false);
  };
  addFreeSeamPoint = (mousePos, line) => {
    this.__seamTool.addFreeSeamPoint(mousePos, line);
  };
  setAbsolutePos = (pos) => {
    //this.__absolutePos = pos;
    this.shapeAbsolute.setAbsolutePos(pos);
  };
  getAbsolutePosition = () => {
    //return this.__absolutePos;
    return this.shapeAbsolute.getAbsolutePosition();
  };
  getPosition = () => {
    let absolutePos = this.getAbsolutePosition();

    if (absolutePos) {
      return absolutePos
    }

    return this.__shape.slabPos;
  };
  setIntersectionsPoints = (points) => {
    this.__intersectionPoints = points;
  };
  setMinLengthToIntersectionPoints = (length) => {
    this.__minLengthToIntersectionPoints = length;
  };
  resetShapeSeams = () => {
    for (let i = this.__shape.shapePieces.length - 1; i >= 0; i--) {
      let shp = workspace.getShapeById(this.__shape.shapePieces[i]);
      if (shp.shapePieces) {
        shp.shapeSlab.resetShapeSeams();
      }
      workspace.removeShape(shp);
    }
    this.__shape.shapePieces.splice(0, this.__shape.shapePieces.length);
  };

  /** Free Seam **/
  setFreeSeamValidation = (lineId, validation) => {
    if (validation) {
      this.__freeSeamValidations.set(lineId, validation);
    } else {
      this.__freeSeamValidations.delete(lineId);
    }
  };
  getFreeSeamValidation = (lineId) => {
    return this.__freeSeamValidations.get(lineId);
  };
  clearFreeSeamValidations = () => {
    this.__freeSeamValidations.clear();
  };
  cleanup = () => {
    this.clearFreeSeamValidations();
  };

  import = (data) => {
    this.shapeAbsolute.setAbsolutePos(data ? data.absolutePosition : null);
  }

  export = () => {
    return {
      absolutePosition: this.getAbsolutePosition()
    }
  }

  getFillTemplate = () => {
    const isBlinkActive = this.__shape.shapeRender.blink.isActive;
    const blinkProgress = this.__shape.shapeRender.blink.progress;
    const colorOverride = this.__shape.shapeRender.blink._colorOverride;

    // Helper to get base colors for different states
    const getBaseColors = () => {
      // Priority: conflict always shows red
      if (this.__shape.isWithConflict) {
        return {
          stroke: COLOR.red,
          fill: COLOR.red_transparent,
          template: RENDER_TEMPLATES.filledRed
        };
      }

      if (this.__shape.isDisabledInPopup) {
        return {
          stroke: COLOR.gray4_transparent,
          fill: COLOR.lightgray4_transparent,
          template: RENDER_TEMPLATES.disabled
        };
      }

      // Get shape color set if available
      const shapeColorSet = this.__shape.getColorSet();
      if (shapeColorSet) {
        return {
          stroke: shapeColorSet.primary_border,
          fill: shapeColorSet.primary,
          template: RENDER_TEMPLATES.accordingToFeature
        };
      }

      // Default colors
      return {
        stroke: COLOR_THEMES[sqftConfig.activeTheme].active,
        fill: COLOR_THEMES[sqftConfig.activeTheme].active_transparent,
        template: RENDER_TEMPLATES.accordingToFeature
      };
    };

    // Helper to get highlight colors based on override
    const getHighlightColors = () => {
      if (colorOverride === 'active') {
        return {
          stroke: COLOR_THEMES[sqftConfig.activeTheme].active_hover,
          fill: COLOR_THEMES[sqftConfig.activeTheme].primary_transparent
        };
      } else if (colorOverride === 'red') {
        return {
          stroke: COLOR.red,
          fill: COLOR.red_transparent
        };
      } else if (colorOverride) {
        return {
          stroke: colorOverride,
          fill: colorOverride
        };
      }

      // Default highlight - use shape colorset if available
      const shapeColorSet = this.__shape.getColorSet();
      if (shapeColorSet) {
        return {
          stroke: shapeColorSet.primary_border,
          fill: shapeColorSet.primary_hover
        };
      }

      return {
        stroke: COLOR_THEMES[sqftConfig.activeTheme].active_hover,
        fill: COLOR_THEMES[sqftConfig.activeTheme].primary_transparent
      };
    };

    // If blink is active, return interpolated colors
    if (isBlinkActive) {
      const baseColors = getBaseColors();
      const highlightColors = getHighlightColors();

      return {
        stroke: pickPulsedColor(
          highlightColors.stroke,
          baseColors.stroke,
          blinkProgress
        ),
        fill: pickPulsedColor(
          highlightColors.fill,
          baseColors.fill,
          blinkProgress
        ),
        isCustomColor: true
      };
    }

    // Return template for normal rendering (conflict will be red, others normal)
    return getBaseColors();
  };

  render = (ctx,
            staticOffset = null,
            strokeTemplate= RENDER_TEMPLATES.default,
            fillTemplate = RENDER_TEMPLATES.accordingToFeature
  ) => {
    if (workspace && workspace.getState().loading) return;
    const reduxState = store.getState()
    const activeButton = reduxState.sqftMenuState.activeButton;

    if (this.__shape.partId === SHAPE_PART_ID.slabPlaceHolder) {
      RenderParts.drawDiagonalStripes(ctx, this.__shape, 2);
    } else {
      // Get fill template with blink support
      const computedFillTemplate = this.getFillTemplate(fillTemplate);
      RenderParts.drawShapeBorders(ctx, staticOffset, strokeTemplate, computedFillTemplate, this.__shape);
    }

    let isMeasurementVisibleInSlabMode = reduxState.sqftSlabState.isMeasurementVisibleInSlabMode;
    if (isMeasurementVisibleInSlabMode) {
      this.renderMeasurementArrows(ctx);
    }
    this.renderSeamLinesOnHover(ctx);
    this.renderSeamCutPoints(ctx);

    // Render free seam indicators
    if (activeButton === SIDEBAR_SLAB_SEAM_BUTTONS.addFreeSeam) {
      this.renderFreeSeamIndicators(ctx);
    }
  };

  renderSeamLinesOnHover = (ctx) => {
    if (this.__shape.isHovering() && workspace.getHoveredSqftShape() === this.__shape ) {
      let sqftMenuState = store.getState().sqftMenuState;
      if (sqftMenuState.activeButton === SIDEBAR_SLAB_SEAM_BUTTONS.addSeamVertical) {
        this.__seamTool.seamToolRender.renderSeamVerticalIntersection(ctx);
      } else if (sqftMenuState.activeButton === SIDEBAR_SLAB_SEAM_BUTTONS.addSeamHorizontal) {
        this.__seamTool.seamToolRender.renderSeamHorizontalIntersection(ctx);
      }
    }
  }

  renderSeamCutPoints = (ctx) => {
    const strokeStyle = '#e01333';
    ctx.save();
    for (const seamCutPoint of this.__shape.seamCutPointsAndLines) {
      const seamCutPointOnField = getPointField(seamCutPoint.point.x, seamCutPoint.point.y, this.__shape);
      RenderFigures.renderCircle(seamCutPointOnField, 4, 1, strokeStyle, strokeStyle);
      RenderFigures.renderCircle(seamCutPointOnField, 7, 1, strokeStyle);
    }
    ctx.setLineDash([5, 5]);
    if (this.__shape.seamCutPointsAndLines.length === 2) {
      const startPoint = this.__shape.seamCutPointsAndLines[0].point;
      const endPoint = this.__shape.seamCutPointsAndLines[1].point;
      const startPointOnField = getPointField(startPoint.x, startPoint.y, this.__shape);
      const endPointOnField = getPointField(endPoint.x, endPoint.y, this.__shape);
      ctx.moveTo(startPointOnField.x, startPointOnField.y);
      ctx.lineTo(endPointOnField.x, endPointOnField.y);
      ctx.strokeStyle = strokeStyle;
      ctx.stroke();
    }
    ctx.setLineDash([]);
    ctx.restore();
  }

  renderFreeSeamIndicators = (ctx) => {
    if (this.__freeSeamValidations.size === 0) return;

    for (const [lineId, validation] of this.__freeSeamValidations) {
      void lineId;
      this.renderFreeSeamIndicator(ctx, validation);
    }
  };

  renderFreeSeamIndicator = (ctx, validation) => {
    if (!validation) return;

    const { canAdd, snapPoint, reason } = validation;
    const pointField = getPointField(snapPoint.x, snapPoint.y, this.__shape);

    const radius = canAdd ? 6 : 8;
    const color = canAdd ? '#4a90e2' : '#ef4444';
    const strokeColor = canAdd ? '#3c76b6' : '#dc2626';

    RenderFigures.renderCircle(pointField, radius, 2, strokeColor, color);

    const hasFirstPoint = this.__shape.seamCutPointsAndLines.length === 1;

    if (hasFirstPoint) {
      const firstPoint = this.__shape.seamCutPointsAndLines[0].point;
      const firstPointField = getPointField(firstPoint.x, firstPoint.y, this.__shape);

      ctx.save();
      ctx.beginPath();
      ctx.setLineDash([5, 5]);
      ctx.strokeStyle = canAdd ? 'rgb(74,144,226)' : 'rgba(239, 68, 68, 0.6)';
      ctx.lineWidth = 2;
      ctx.moveTo(firstPointField.x, firstPointField.y);
      ctx.lineTo(pointField.x, pointField.y);
      ctx.stroke();
      ctx.setLineDash([]);
      ctx.restore();
    }

    if (!canAdd && reason && reason !== 'intersects_boundary') {
      const reasonText = reason === 'same_line'
        ? 'SAME LINE'
        : 'boundary crossing';

      if (reasonText) {
        ctx.save();
        ctx.font = '10px Arial';
        ctx.fillStyle = '#dc2626';
        ctx.fillText(reasonText, pointField.x + 12, pointField.y - 12);
        ctx.restore();
      }
    }
  };

  renderLinesWithoutStroke = (ctx, staticOffset = null, sqftMode) => {
    if (workspace && workspace.getState().loading) return;
    let lines = this.__shape.getLines();
    ctx.lineWidth = 2;
    ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].active;
    for (let i = 0; i < lines.length; i++) {
      lines[i].staticOffset = staticOffset;
      lines[i].render(ctx, i > 0, sqftMode);
      lines[i].staticOffset = null;
    }
  };

  renderMeasurementArrows = (ctx) => {
    const snappedShapeGroup = this.shapeAbsolute.getSnappedShapeGroup();
    if (snappedShapeGroup !== null) {
      const snappedShapes = workspaceControllers.snappedShapeGroups.getSnappedShapes(snappedShapeGroup);
      if (snappedShapes.length > 1) {
        return
      }
    }

    this.__measurementArrows.render(ctx);
  };
}

export default ShapeSlab
